import React from 'react';
import ShieldGreyIcon from 'assets/images/icons/shield_grey.svg';
import ShieldGreenIcon from 'assets/images/icons/shield_green.svg';
import ShieldBlueIcon from 'assets/images/icons/shield_blue.svg';
import ShieldVerifiedIcon from 'assets/images/icons/verified-icon.svg';
import ShieldNotverifiedIcon from 'assets/images/icons/notverified.svg';
import YellowIcon from 'assets/images/icons/Badge_yellow.svg';
import BronzeIcon from 'assets/images/icons/Badge_bronze.svg';
import SilverIcon from 'assets/images/icons/Badge_silver.svg';
import BlueIcon from 'assets/images/icons/Badge_blue.svg';
import GreenIcon from 'assets/images/icons/Badge_green.svg';
import { Popover } from 'antd';

const Shield = ({ dealVerifiedIcon, tickvalue, dontShowPopUp, onClick, isProfile, shieldText, ...rest }) => {

  const loc = window.location.href;
  const isSocialProfileAboutSection = loc.includes("/social/profile/about")
  //   const tickvalue = 1;
  let shieldIcon = null;
  let message = '';
  let messageColor = '';
  switch (tickvalue) {
    case 1:
    case '1':
      shieldIcon = BlueIcon;
      message = 'Verified Blue';
      messageColor = '#1B62AB';
      break;
    case 2:
    case '2':
      shieldIcon = GreenIcon;
      message = 'Verified Green';
      messageColor = '#599906';
      break;
    case 3:
    case '3':
      shieldIcon = SilverIcon;
      message = 'Verified Silver';
      messageColor = "#a3a3a3";
      break;
    case 4:
    case '4':
      // case 0:
      // case '0':
      shieldIcon = BronzeIcon;
      message = 'Verified Bronze';
      messageColor = "#b45309";
      break;
    case 0:
    case '0':
      // case 0:
      // case '0':
      shieldIcon = ShieldNotverifiedIcon;
      message = 'KYC Verified';
      messageColor = '#ff8080';
      break;
    case 5:
    case '5':
      // case 0:
      // case '0':
      shieldIcon = YellowIcon;
      message = 'Verified Yellow';
      messageColor = "#f97316";
      break;
      case 6:
      case '6':
      // case 0:
      // case '0':
      shieldIcon = YellowIcon;
      message = 'KYC Verified Yellow';
      messageColor = "#f97316";
      break;
      case 10:
      case '10':
        // case 0:
        // case '0':
        shieldIcon = ShieldNotverifiedIcon;
        message = 'KYC Verified';
        messageColor = '#ff8080';
        break;

  }

  const content = (
    <div className="p-0" style={{zIndex: 10000}}>
      <p className="rating-heading" style={{ textAlign: 'center', fontSize: 'var(--fs-base__four)', color: messageColor }}>
        {message}
      </p>
    </div>
  );

  return (
    <>
      {(tickvalue || tickvalue == 0) ? (
        dontShowPopUp != true ? (
          dealVerifiedIcon ? (
            <img src={shieldIcon} alt="" height="34" style={{ marginTop: '-3px', ...rest?.style }} />
          ) : (
            isProfile ? (
              <Popover zIndex={1400} placement="rightTop" content={'Verified Supplier'} >
                <img src={shieldIcon} alt="" height="20" style={{ marginTop: '-3px', ...rest?.style }} className="ml-auto mr-auto" onClick={onClick} />
              </Popover>
            ) : (
              shieldText ? (
                <>
                  <img src={shieldIcon} alt="" height="20" style={{ width: 'auto' }} />
                 {
                  !isSocialProfileAboutSection && <p className="m-0 fw-900" style={{ color: 'var(--unnamed-color-1b62ab)', fontFamily: 'sans-serif' }}>{message}</p>
                 }
                </>
              ) : (
                <>
                <img src={shieldIcon} alt="" height="18" style={{ marginTop: '-3px', ...rest?.style }} className="ml-auto mr-auto" onClick={onClick} />
                </>
              )
            )
          )
        ) : (
          <Popover zIndex={1400} placement="rightTop" content={content}>
            {dealVerifiedIcon ? <img src={shieldIcon} alt="" height="26" style={{ marginTop: '-3px', ...rest?.style }} /> : <img src={shieldIcon} alt="" height="20" style={{ marginTop: '-3px', ...rest?.style }} />}
          </Popover>
        )
      ) : null}
    </>
  );
};

export default Shield;
